export const WEB_APP_HOSTNAMES = [
    "localhost",
    "cm.cash.sbox.bankifi.com",
    "cm.test.sbox.bankifi.com",
    "cm.aqua.sbox.bankifi.com",
    "cm.revenu.sbox.bankifi.com"
]

export const MOBILE_APP_SCHEMES = ["exp:", "incomeing:", "asbbankifi:", "revenu:", "gogetpaid:", "axiomgo:", "invoiceit:"]
